import GroupNotification from "../../components/Group/GroupNotification/GroupNotification";

const CreateGroupNotification = () => {
  return <GroupNotification isNew={true} />;
};
export default CreateGroupNotification;
